import React from 'react';
import { Box } from 'theme-ui';
import Search from './Search';

interface SearchDialogProps {
  onClose: () => void;
  hasFocus?: boolean;
}

const SearchDialog: React.FC<SearchDialogProps> = ({ onClose, hasFocus }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bg: 'overlay',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <Box
        sx={{
          bg: 'background',
          p: [3, 4],
          borderRadius: 4,
          width: ['100vw', '650px'],
          height: ['100vh', '50vh'],
          boxShadow: 'shadow',
          position: 'relative',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Search
          indices={[{ name: 'Articles', title: 'Articles' }]}
          onClose={onClose}
          hasFocus={hasFocus}
        />
      </Box>
    </Box>
  );
};

export default SearchDialog;
